import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en.json";
import deCHTranslation from "./locales/de-CH.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation.translation,
      },
      "de-CH": {
        translation: deCHTranslation.translation,
      },
    },
    supportedLngs: ["de-CH", "en"],
    fallbackLng: "de-CH", // fallback language if translation is not found
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) =>
        lng.toLowerCase().startsWith("de") ? "de-CH" : "en",
    },
  });

/**
 * Keep <html lang> in step with the language actually being rendered.
 *
 * index.html ships lang="de-CH" because German is the fallback, but the
 * detector may resolve to English — and a page that renders English while
 * declaring German makes mobile browsers offer to translate it, and misleads
 * screen readers about pronunciation. i18next resolves the language during
 * init above, which runs before React mounts, so the first paint is already
 * correct.
 */
const syncDocumentLanguage = (language) => {
  if (typeof document !== "undefined" && language) {
    document.documentElement.lang = language;
  }
};

syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
